import { mix } from "@chorda/core";
import { Link, List } from "../simple";
export const Tab = (props) => {
    return mix({
        templates: {
            content: Link
        },
        reactions: {
            active: (v) => ({ classes: { 'is-active': v } })
        },
    }, {
        injections: {
            text: props.text$,
            link: props.link$,
            active: props.active$,
            name: () => props.name
        },
        classes: {
            'is-active': props.active
        },
        events: {
            $dom: {
                click: props.onClick
            }
        },
        templates: {
            content: Link({
                text: props.text,
                link: props.link
            })
        }
    });
};
export const Tabs = (props) => {
    return mix({
        css: 'tabs',
        templates: {
            content: List
        }
    }, props && {
        classes: {
            'is-centered': props.centered,
            'is-right': props.right,
        },
        injections: {
            tabs: props.tabs$
        },
        defaults: {
            tabs: () => null
        },
        templates: {
            content: List({
                items$: (scope) => scope.tabs,
                items: props.tabs,
                defaultItem: props.defaultTab
            })
        }
    });
};
